import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var state = {
  nodeMap: new Map(),
  isEdit: null,
  selectedNode: {},
  selectFormItem: null,
  design: {}
};
var mutations = {
  SELECTED_NODE: function SELECTED_NODE(state, val) {
    state.selectedNode = val;
  },
  DESIGN: function DESIGN(state, val) {
    state.design = val;
  },
  IS_EDIT: function IS_EDIT(state, val) {
    state.isEdit = val;
  }
};
var actions = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};